module.exports = __webpack_public_path__ + "img/Rheinland_Certified_ISO27001_2022.105fc62c.png";